/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const escoSkillIndexDataSchema = z.object({
	q: z.string().nullable().optional(),
})

export type EscoSkillIndexDataSchema = z.infer<typeof escoSkillIndexDataSchema>
